import DetailVM from './detail-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init : function(element) {
    const portfolio_project_data = JSON.parse(element.dataset.portfolioProjectJson);
    let vm = new Vue(DetailVM);
    vm.bindData(portfolio_project_data);
    vm.$mount(element);
  }
};
